import _ from 'lodash';
import { connect } from 'react-redux';
import { search, estimate } from '../../modules/logistics/stationDelivery';
import { bindActionCreators } from 'redux';
import { showErrors } from '../../modules/general';

const mapStateToProps = state => {

	/** @namespace state.lists.stationDeliveryIds **/
	/** @namespace state.maps.stationDelivery **/
	/** @namespace state.maps.user **/
	let deliveries = [];
	if (state.lists.stationDeliveryIds) {
		deliveries = _.map(state.lists.stationDeliveryIds, id => state.maps.stationDelivery[id]);
	}

	const estimatesByStationTank = state.logisticsDelivery.estimatesByStationTank;

	return {
		deliveries,
		estimatesByStationTank,
		stationMap : state.maps.station,
		userMap : state.maps.user,
		carrierMap : state.maps.carrier,
		terminalMap : state.maps.terminal,
		supplierMap : state.maps.supplier,
		authUser : state.auth.authUser,
	};
};
const mapDispatchToProps = dispatch => bindActionCreators({
	searchDeliveries : search,
	estimateDeliveries : estimate,
	showErrors,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);